import {
  ActiveUser,
  Admins,
  AdminUser,
  Branches,
  Cabinets,
  CanceledRequests,
  Dashboard,
  FileIcon,
  History,
  HQBranches,
  LogoutIcon,
  MultiUsers,
  Password,
  Phone,
  Requests,
  Settings,
  SingleFile,
  UnactiveUser,
  UserIcon,
  Users,
} from "../../components/styled/AllImages";
import {
  SelectDepartment,
  SelectMember,
  TransferTo,
} from "../../pages/admin/cabinets/components/TransferSteps";
import ReceivedRequests from "../../pages/admin/requests/ReceivedRequests";
import SentRequests from "../../pages/admin/requests/SentRequests";
import TempUserPermissions from "../../pages/admin/users/components/TempUserPermissions";
import TempUserPersonalInfo from "../../pages/admin/users/components/TempUserPersonalInfo";
import UserPermissions from "../../pages/admin/users/components/UserPermissions";
import UserPersonalInfo from "../../pages/admin/users/components/UserPersonalInfo";

export const SidebarList = [
  {
    title: "dashboard",
    icon: Dashboard,
    url: "dashboard",
    id: 1,
  },
  {
    title: "cabinets",
    icon: Cabinets,
    id: 2,
    permission: {
      collection: 1,
      action: 1,
    },
    submenu: [
      {
        title: "normal_cabinets",
        url: "cabinets",
      },
      {
        title: "temporary_cabinets",
        url: "temporary-cabinets",
      },
    ],
  },
  {
    title: "requests",
    icon: Requests,
    url: "requests",
    id: 3,
    permission: {
      collection: 5,
      action: 1,
      feature: 4,
    },
  },
  {
    title: "access_log",
    icon: History,
    url: "access-log",
    id: 4,
    permission: {
      collection: 6,
      action: 1,
      feature: 1,
    },
  },
  {
    title: "users",
    icon: Users,
    id: 5,
    // url: "users",
    permission: {
      collection: 4,
      action: 1,
    },
    submenu: [
      {
        title: "organization_users",
        url: "users",
      },
      {
        title: "temporary_users",
        url: "temporary-users",
      },
    ],
  },
  {
    title: "org_structure",
    icon: HQBranches,
    url: "org-structure",
    id: 6,
  },
  {
  	title: "referrals",
  	icon: Phone,
  	url: "referrals",
    id: 'referrals'
  },
  {
    title: "settings",
    icon: Settings,
    // url: "settings",
    id: 7,
    submenu: [
      {
        title: "overview",
        url: "settings/overview",
      },
      {
        title: "establishment",
        url: "settings/establishment",
      },
      {
        title: "admin_director",
        url: "settings/admin-director",
      },
      {
        title: "admins_list",
        url: "settings/admins-list",
      },
      {
        title: "billing",
        url: "settings/billing",
      },
    ],
  },
  // {
  // 	title: "support",
  // 	icon: Phone,
  // 	url: "support",
  // },
];

export const supportDropdownList = [
  {
    label: "message_ca_manager",
    path: "",
  },
  {
    label: "message_ca_support",
    path: "",
  },
];

export const dashboardTileArray = [
  {
    icon: Cabinets,
    count: "0",
    color: "var(--white)",
    bg: "var(--themeColor)",
    title: "total_cabinets",
    collection: 1,
    action: 1,
  },
  {
    icon: SingleFile,
    count: "0",
    color: "var(--white)",
    bg: "var(--redColor2)",
    title: "total_files",
    collection: 2,
    action: 1,
  },
  {
    icon: FileIcon,
    count: "0",
    color: "var(--white)",
    bg: "var(--lightBlue)",
    title: "total_archives",
    collection: 3,
    action: 1,
  },
  {
    icon: MultiUsers,
    count: "0",
    color: "var(--white)",
    bg: "var(--yellow2)",
    title: "total_users",
    collection: 4,
    action: 1,
  },
  {
    icon: Requests,
    count: "0",
    color: "var(--white)",
    bg: "var(--yellow)",
    title: "total_requests",
    collection: 5,
    action: 1,
    feature: 4,
  },
  {
    icon: Requests,
    count: "0",
    color: "var(--white)",
    bg: "var(--purple)",
    title: "total_open_requests",
    collection: 5,
    action: 1,
    feature: 4,
  },
  {
    icon: CanceledRequests,
    count: "0",
    color: "var(--white)",
    bg: "var(--redColor)",
    title: "total_canceled_requests",
    collection: 5,
    action: 1,
    feature: 4,
  },
  {
    icon: HQBranches,
    count: "0",
    color: "var(--white)",
    bg: "var(--themeColor2)",
    title: "total_org_structure",
    collection: 7,
    action: 1,
  },
];
export const ProfileSidebarList = [
  {
    title: "AccountSetting",
    icon: Password,
    url: "",
  },
  {
    title: "ChangePassword",
    icon: UserIcon,
    url: "",
  },
  {
    title: "Logout",
    icon: LogoutIcon,
    url: "#!",
  },
];
export const fileTileArray = [
  {
    icon: SingleFile,
    count: "0",
    color: "var(--white)",
    bg: "var(--redColor2)",
    title: "ActiveFiles",
  },
  {
    icon: SingleFile,
    count: "0",
    color: "var(--white)",
    bg: "var(--themeColor2)",
    title: "InactiveFile",
  },
  {
    icon: SingleFile,
    count: "0",
    color: "var(--white)",
    bg: "var(--redColor)",
    title: "TotalFiles",
  },
];

export const usersTileArray = [
  {
    icon: MultiUsers,
    count: "0",
    color: "var(--white)",
    bg: "var(--lightBlue)",
    title: "total_accounts",
  },
  {
    icon: MultiUsers,
    count: "0",
    color: "var(--white)",
    bg: "var(--yellow2)",
    title: "total_users",
  },
  {
    icon: AdminUser,
    count: "0",
    color: "var(--white)",
    bg: "var(--purple)",
    title: "total_admins",
  },
  {
    icon: ActiveUser,
    count: "0",
    color: "var(--white)",
    bg: "var(--themeColor2)",
    title: "activated_users",
  },
  {
    icon: UnactiveUser,
    count: "0",
    color: "var(--white)",
    bg: "var(--redColor)",
    title: "deactivated_users",
  },
];
export const TempUsersTileArray = [
  {
    icon: MultiUsers,
    count: "0",
    color: "var(--white)",
    bg: "var(--yellow2)",
    title: "total_users",
  },

  {
    icon: ActiveUser,
    count: "0",
    color: "var(--white)",
    bg: "var(--themeColor2)",
    title: "activated_users",
  },
  {
    icon: UnactiveUser,
    count: "0",
    color: "var(--white)",
    bg: "var(--redColor)",
    title: "deactivated_users",
  },
];
export const hqBranchTileArray = [
  {
    icon: HQBranches,
    count: "0",
    color: "var(--white)",
    bg: "var(--yellow2)",
    title: "total_branches",
  },
  {
    icon: HQBranches,
    count: "0",
    color: "var(--white)",
    bg: "var(--purple)",
    title: "TotalHeadquarters",
  },
];

export const requestsTabs = [
  {
    id: 1,
    title: "received_requests",
    component: ReceivedRequests,
  },
  {
    id: 2,
    title: "sent_requests",
    component: SentRequests,
  },
];
export const userFormTabs = [
  {
    id: 1,
    title: "personal_information",
    component: UserPersonalInfo,
    fields: [
      "name",
      "email",
      "phone",
      "password",
      "confirm_password",
      "location_id",
      "department_id",
      "user_type_id",
      "id_number",
      "position",
      "location",
      "date_of_birth",
      "licenses_allowed",
      "upload_id",
      "upload_job_id",
    ],
  },
  {
    id: 2,
    title: "rights_permissions",
    component: UserPermissions,
  },
];
export const tempUserFormTabs = [
  {
    id: 1,
    title: "personal_information",
    component: TempUserPersonalInfo,
    fields: ["name", "email", "phone"],
  },
  {
    id: 2,
    title: "rights_permissions",
    component: TempUserPermissions,
  },
];

export const overviewTileArray = [
  {
    icon: Branches,
    count: "",
    color: "var(--white)",
    bg: "var(--yellow2)",
    title: "TotalBranches",
  },
  {
    icon: Branches,
    count: "",
    color: "var(--white)",
    bg: "var(--purple)",
    title: "TotalHeadquarters",
  },
  {
    icon: Admins,
    count: "",
    color: "var(--white)",
    bg: "var(--themeColor2)",
    title: "TotalAdmins",
  },
];

export const viewDetailArray = [
  {
    title: "AdminName",
    value: "Guy Hawkins",
  },
  {
    title: "email",
    value: "guyhawkins@example.com",
  },
  {
    title: "ContactNo",
    value: "(207) 555-0119",
  },
  {
    title: "numOfLicensePlaceholder",
    value: "524",
  },
  {
    title: "NoofUsersCreated",
    value: "954",
  },
  {
    title: "no_of_licenses_left",
    value: "726",
  },
];

export const stepsToTransfer = [
  { title: "transfer_to", component: TransferTo },
  { title: "select_department", component: SelectDepartment },
  { title: "transfer_to", component: SelectMember },
];

export const roleOptions = [
  { label: "CXO", value: "CXO" },
  { label: "VP", value: "VP" },
  { label: "Director", value: "Director" },
  { label: "Manager", value: "Manager" },
  { label: "Contributor", value: "Contributor" },
];

export const companySizeOptions = [
  { label: "1-15", value: "1-15" },
  { label: "16-100", value: "16-100" },
  { label: "101-500", value: "101-500" },
  { label: "501-1000", value: "501-1000" },
  { label: "1001+", value: "1001+" },
];

export const salesHelpOptions = [
  {
    label: "want_to_evaluate_cloud_archive",
    value: "want_to_evaluate_cloud_archive",
  },
  {
    label: "want_to_understand_cloud_archive",
    value: "want_to_understand_cloud_archive",
  },
  { label: "want_to_buy_licenses", value: "want_to_buy_licenses" },
  { label: "have_product_question", value: "have_product_question" },
  { label: "need_compliance_plan", value: "need_compliance_plan" },
];

export const referralsTileArray = [
  {
    icon: MultiUsers, 
    count: "0",
    color: "var(--white)",
    bg: "var(--lightBlue)",
    title: "total_referrals",
  },
  {
    icon: ActiveUser, 
    count: "0",
    color: "var(--white)",
    bg: "var(--yellow2)",
    title: "pending_referrals",
  },
  // {
  //   icon: ActiveUser,
  //   count: "0",
  //   color: "var(--white)",
  //   bg: "var(--themeColor2)",
  //   title: "accepted_referrals",
  // },
  // {
  //   icon: UnactiveUser,
  //   count: "0",
  //   color: "var(--white)",
  //   bg: "var(--redColor)",
  //   title: "rejected_referrals",
  // },
];
